<template>
  <v-container class="py-0" :class="bgColor" fluid style="min-height:300px">
    <v-row>
      <v-col cols="12" sm="6" md="4" lg="3" xl="3" align="center" class="align-self-center" v-if="(macros || []).length < 10">
        <v-btn text depressed dark color="grey" @click="addMacroClick">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="3" v-for="(m, i) in macros" :key="i">
        <v-card flat outlined tile @click="onMacroClick(m, i, macros)">
          <v-list-item>
            <v-list-item-avatar>
              <v-icon :class="m.enable ? 'green--text' : 'grey--text'">{{m.enable ? 'mdi-cast-connected' : 'mdi-cast'}}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title ">{{ m.name }}</v-list-item-title>
              <v-list-item-subtitle>
                <span class="subtitle-1">{{$tc('triggers', m.triggers ? Object.values(m.triggers).length : 0)}}</span>&nbsp;
                <span class="subtitle-1">{{$tc('actions', m.actions ? Object.values(m.actions).length : 0)}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import User from '@/components/auth/User'
export default {
  name: 'PanelDetailMacro',
  mixins: [User],
  props: {
    pie: {
      type: String
    },
    macros: {
      type: Array
    },
    bgColor: {
      type: String
    }
  },
  methods: {
    onMacroClick(m, i, macros) {
      this.$emit('macroClick', m, i, macros);
    },
    addMacroClick() {
      this.$emit('addMacroClick', this.macros);
    }
  }
}
</script>